import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingOverlayService {
  private readonly shouldShow$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get shouldShow(): Observable<boolean> {
    return this.shouldShow$.asObservable();
  }

  public show = (): void => {
    this.shouldShow$.next(true);
  };

  public hide = (): void => {
    this.shouldShow$.next(false);
  };
}
